import * as React from 'react';
import { FC } from 'react';
import { useContext } from "react";
import { Feedback, Footer, IntegrationFooter } from 'deda-rkit';
import { BrowserRouter as Router} from 'react-router-dom';
import { AppCtx } from './mixin/app_context';

const logo = require('../../../img/logo.svg');
export const App: FC = () => {

  const context = useContext(AppCtx);
  const appNome = (document.querySelector('#appNome') as HTMLElement)?.dataset.appNome;
  const tipoPagina = (document.querySelector('#tipoPagina') as HTMLElement)?.dataset.tipoPagina;
  const servizioTipologia = (document.querySelector('#breadcrumb') as HTMLElement)?.dataset.servizioTipologia;

  
  return (
    <Router>
      {context?.confEnte.codice_fiscale && appNome && (
        <Feedback
          parametri={{
            clientID: "",
            codiceFiscaleEnte: context?.confEnte.codice_fiscale,
            dominioEnte: context?.confEnte.domain,
            servizio: appNome,
            urlInvioFeedback: context?.confEnte.url_app_feedback,
            tipologiaServizio: servizioTipologia
          }}
          tipoPagina={
           tipoPagina? tipoPagina : "servizio"
          }
          key={document.location.pathname}
        ></Feedback>
      )}
      {(context?.confEnte.external_footer != null && 
        context?.confEnte.external_footer != '' &&
        context?.confEnte.external_header != null &&
        context?.confEnte.external_header != ''
        )?
        <IntegrationFooter urlFetch={context.confEnte.external_footer}/>
        :
        <Footer
          nomeEnte={context?.confEnte.nome}
          logoEnte={context?.confEnte.stemma}
          logoUE={context?.confEnte.logo_eu}
          logoDeda={context?.confEnte.logo_deda}
          cellulare={context?.confEnte.cellulare}
          iban={context?.confEnte.iban}
          indirizzo={context?.confEnte.indirizzo}
          linkAccessibilita={context?.confEnte.link_accessibilita}
          linkAppuntamenti={context?.confEnte.link_appuntamenti}
          linkNoteLegali={context?.confEnte.link_note_legali}
          linkGdpr={context?.confEnte.link_gdpr}
          sezServizi = {context?.confEnte.ft_sez_servizi}
          sezAContatti = {context?.confEnte.ft_sez_a_contatti}
          sezBContatti = {context?.confEnte.ft_sez_b_contatti}
          sezPoweredBy = {context?.confEnte.ft_sez_poweredby}
          sezImmagine = {context?.confEnte.ft_sez_immagine}
          partitaIva={context?.confEnte.partita_iva}
          pec={context?.confEnte.pec}
          telefono={context?.confEnte.telefono}
          linkUrp = {context?.confEnte.link_urp}
          numeroVerde = {context?.confEnte.numero_verde}
          navigazioneReact = {context?.confEnte.navigazione_react}
          baseUrl = {context?.confEnte.base_url}
          footerLinks = {context?.confEnte.header_links}
          
        />
      }
    </Router>
  );
}